import { Skeleton } from "@/components/ui/skeleton";
import { Separator } from "@/components/ui/separator";

export default function CartSkeleton() {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header Skeleton */}
      <div className="bg-white border-b">
        <div className="container mx-auto px-4 py-6">
          <div className="flex items-center gap-4">
            <Skeleton className="h-5 w-32" />
            <Skeleton className="h-6 w-16 rounded-full" />
          </div>
        </div>
      </div>

      <div className="container mx-auto px-4 py-12">
        <div className="grid lg:grid-cols-3 gap-8">
          {/* Cart Items Section */}
          <div className="lg:col-span-2 space-y-6">
            {/* Cart Items List Skeleton */}
            <div className="bg-white rounded-lg shadow-sm">
              {[1, 2, 3].map((item) => (
                <div key={item}>
                  <div className="p-6">
                    <div className="flex gap-4">
                      {/* Product Image Skeleton */}
                      <Skeleton className="w-[120px] h-[120px] rounded-lg" />

                      {/* Product Details Skeleton */}
                      <div className="flex-1">
                        <div className="flex justify-between items-start">
                          <div className="flex-1">
                            {/* Product Name */}
                            <Skeleton className="h-6 w-3/4 mb-2" />
                            {/* Product Description */}
                            <Skeleton className="h-4 w-full mb-2" />
                            <Skeleton className="h-4 w-2/3 mb-3" />
                            {/* Price */}
                            <div className="flex items-center gap-2">
                              <Skeleton className="h-6 w-24" />
                              <Skeleton className="h-4 w-20" />
                            </div>
                          </div>
                          {/* Remove Button Skeleton */}
                          <Skeleton className="h-8 w-8 rounded-full" />
                        </div>

                        {/* Quantity Controls Skeleton */}
                        <div className="flex items-center justify-between mt-4">
                          <div className="flex items-center gap-3">
                            <Skeleton className="h-4 w-16" />
                            <div className="flex items-center border border-gray-200 rounded-lg">
                              <Skeleton className="h-8 w-8" />
                              <Skeleton className="h-6 w-8 mx-3" />
                              <Skeleton className="h-8 w-8" />
                            </div>
                          </div>
                          {/* Total Price Skeleton */}
                          <Skeleton className="h-6 w-24" />
                        </div>
                      </div>
                    </div>
                  </div>
                  {item < 3 && <Separator />}
                </div>
              ))}
            </div>

            {/* Promo Code Skeleton */}
            <div className="bg-white rounded-lg shadow-sm p-6">
              <Skeleton className="h-6 w-32 mb-4" />
              <div className="flex gap-3">
                <Skeleton className="flex-1 h-10" />
                <Skeleton className="h-10 w-24" />
              </div>
            </div>
          </div>

          {/* Order Summary Skeleton */}
          <div className="lg:col-span-1">
            <div className="bg-white rounded-lg shadow-sm p-6 sticky top-6">
              <Skeleton className="h-7 w-40 mb-6" />

              <div className="space-y-4">
                {/* Subtotal */}
                <div className="flex justify-between">
                  <Skeleton className="h-4 w-32" />
                  <Skeleton className="h-4 w-20" />
                </div>

                {/* Shipping */}
                <div className="flex justify-between">
                  <Skeleton className="h-4 w-20" />
                  <Skeleton className="h-4 w-16" />
                </div>

                <Separator />

                {/* Total */}
                <div className="flex justify-between">
                  <Skeleton className="h-6 w-16" />
                  <Skeleton className="h-6 w-24" />
                </div>
              </div>

              {/* Checkout Button Skeleton */}
              <Skeleton className="w-full h-12 mt-6 rounded-md" />

              {/* Security Features Skeleton */}
              <div className="mt-6 space-y-3">
                <div className="flex items-center gap-2">
                  <Skeleton className="h-4 w-4 rounded-full" />
                  <Skeleton className="h-4 w-48" />
                </div>
                <div className="flex items-center gap-2">
                  <Skeleton className="h-4 w-4 rounded-full" />
                  <Skeleton className="h-4 w-40" />
                </div>
              </div>

              {/* Payment Methods Skeleton */}
              <div className="mt-6 pt-6 border-t">
                <Skeleton className="h-4 w-24 mb-3" />
                <div className="flex gap-2">
                  {[1, 2, 3].map((item) => (
                    <Skeleton key={item} className="h-7 w-24 rounded" />
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

